// §2.5 Kbd hint, set in t-label (never mono).
export default function Kbd({ children }) {
  return <kbd className="ui ui-kbd">{children}</kbd>;
}
